import { useQuery } from "@apollo/client";
import { CompanySearchResponse } from "../../../../../types/companySearch";
import { FuzzySearchFilterValue } from "../../../../../legacy/types/misc";
import { COMPANY_SEARCH_SLIM_QUERY } from "../../../../../apis/companySearch/companyList";
import { isEmpty } from "../../../../../utils/jsUtils";
import { COMPANY_SEARCH_CLIENT } from "../../../../../utils/consts";

const generateLabel = (
  filter: FuzzySearchFilterValue,
  nameCache: CompanySearchResponse
) => {
  const { hgIds = [], hgIdsIncludingCorporateRelatives = [] } = filter;

  const singleName = nameCache?.search?.data?.[0]?.name || "";

  if (!isEmpty(hgIds)) {
    return hgIds.length === 1 ? singleName : `${hgIds.length} selected`;
  }

  if (!isEmpty(hgIdsIncludingCorporateRelatives)) {
    return hgIdsIncludingCorporateRelatives.length === 1
      ? singleName
      : `${hgIdsIncludingCorporateRelatives.length} selected`;
  }

  return "All";
};

export const useTargetOrganizationsLabel = (filter: FuzzySearchFilterValue) => {
  const hgIds = [
    ...(filter?.hgIds || []),
    ...(filter?.hgIdsIncludingCorporateRelatives || []),
  ];

  const { data: nameCache } = useQuery<CompanySearchResponse>(
    COMPANY_SEARCH_SLIM_QUERY,
    {
      variables: {
        filters: { hgIds },
        per: 1,
      },
      skip: hgIds.length === 0,
      context: {
        clientName: COMPANY_SEARCH_CLIENT,
      },
    }
  );

  return generateLabel(filter, nameCache as CompanySearchResponse);
};
